<script>
    import Founder from './founder.svelte';
    import Executives from './executives.svelte';
    import Government from './government.svelte';
    import Investors from './investors.svelte';
    $: console.log('current1', current1);
    let current1 = 'founders';
    let navBackDiv;
    let menu = '';
    export let navColor;
    let backgroundcolor;
    let colorFont;
    let textColor;
    export let btnColor;
    export let backgroundColor = '#3c74c0';
    export let Opacity = '1';
    export const btnTextColor = 'black';
    export let stroke = '#3C74C0';
    // export let animation = 'none';
    export const top = '3.3';
    let closediv;
    let sideMenu;
    let sideMenuInner;
    if (navColor == 'black') {
        backgroundcolor = '#3c74c0';
        colorFont = 'white';
        btnColor = 'white';
        textColor = '#00204B';
    } else {
        backgroundcolor = 'white';
        colorFont = '#00204B';
        btnColor = '#3c74c0';
        textColor = 'white';
    }
    let arrowdown;
    let arrowdown2;
    let arrowdown3;
    let arrowdown4;
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<div class="desktop">
    <div class="content-section " style=" background-color: {backgroundcolor}">
        <div
            style="position: relative;"
            on:mouseenter={() => {
                menu = '';
                navBackDiv.style.display = 'none';
                current1 = '';
            }}
        >
            <div class="navBackDiv" bind:this={navBackDiv} />
            <ul class="nav-list" style="color: {colorFont};">
                <li
                    class={current1 === 'founder' ? 'select' : ''}
                    on:mouseenter={() => {
                        current1 = 'founder';
                        navBackDiv.style.left = '1.5vw';
                        navBackDiv.style.display = 'block';
                        closediv.style.display = 'block';
                        menu = 'founder';
                    }}
                >
                    Founder
                </li>
                <li
                    class={current1 === 'executives' ? 'select ani2' : ''}
                    on:mouseenter={() => {
                        current1 = 'executives';
                        navBackDiv.style.left = '10vw';
                        navBackDiv.style.display = 'block';
                        closediv.style.display = 'block';
                        menu = 'executives';
                    }}
                >
                    Executives
                </li>
                <li
                    class={current1 === 'investors' ? 'select' : ''}
                    on:mouseenter={() => {
                        current1 = 'investors';
                        navBackDiv.style.left = '19vw';
                        navBackDiv.style.display = 'block';
                        closediv.style.display = 'block';
                        menu = 'investors';
                    }}
                >
                    Investors
                </li>
                <li
                    class={current1 === 'government' ? 'select' : ''}
                    on:mouseenter={() => {
                        current1 = 'government';
                        navBackDiv.style.left = '28.2vw';
                        navBackDiv.style.display = 'block';
                        closediv.style.display = 'block';
                        menu = 'government';
                    }}
                >
                    Government
                </li>
                <li
                    on:mouseenter={() => {
                        menu = '';
                        navBackDiv.style.display = 'none';
                        current1 = '';
                    }}
                    class="contactUs"
                    on:click={() => {
                        location.href = '/contact_us';
                    }}
                >
                    Contact Us
                </li>
            </ul>
        </div>
        <div>
            <button
                style=" background-color: {btnColor};  color: {textColor}"
                on:click={() => (location.href = 'alumni')}
            >
                Alumni Success Stories
            </button>
        </div>
    </div>
    <div
        class="form-background"
        bind:this={closediv}
        on:mouseenter={() => {
            navBackDiv.style.display = 'none';
            closediv.style.display = 'none';
            menu = '';
            current1 = '';
        }}
    />
    <div class="header-div">
        {#if menu === 'founder'}
            <div
                style="    
                width: 75.3vw;
                margin-left: -11.2vw;
                height: 3vw;
                background-color: transparent;"
            />
            <div class="form-animation">
                <Founder />
            </div>
        {/if}
        {#if menu === 'executives'}
            <div
                style="    
                width: 75.3vw;
                margin-left: -11.2vw;
                height: 3vw;
                background-color: transparent;"
            />
            <div class="form-animation">
                <Executives />
            </div>
        {/if}
        {#if menu === 'government'}
            <div
                style="   
                width: 75.3vw;
                margin-left: -11.2vw;
                height: 3vw;
                background-color: transparent;"
            />
            <div class="form-animation">
                <Government />
            </div>
        {/if}
        {#if menu === 'investors'}
            <div
                style="    
                width: 75.3vw;
                margin-left: -11.2vw;
                height: 3vw;
                background-color: transparent;"
            />
            <div class="form-animation">
                <Investors />
            </div>
        {/if}
    </div>
</div>

<div class="mobi">
    <div class="mobile">
        <div
            class="main-div"
            style="background-color:{backgroundColor}; opacity:{Opacity}"
        >
            <div
                class="logo-img"
                bind:this={menu}
                on:click={() => {
                    menu = '';
                }}
            >
                <img
                    src="/images/header/draper_logo.svg"
                    alt=" "
                    width="100%"
                    on:click={() => (location.href = '/')}
                />
            </div>
            <div
                class="menu-icon"
                on:click={() => {
                    sideMenu.style.left = '0';
                    sideMenu.style.transitionDuration = '1s';
                    sideMenuInner.style.left = '33vw';
                    sideMenuInner.style.transitionDuration = '1s';
                }}
            >
                <svg
                    width="38"
                    height="26"
                    viewBox="0 0 38 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <line y1="1.5" x2="38" y2="1.5" {stroke} stroke-width="3" />
                    <line
                        x1="8"
                        y1="9.28125"
                        x2="38"
                        y2="9.28125"
                        {stroke}
                        stroke-width="3"
                    />
                    <line
                        x1="14"
                        y1="17.5"
                        x2="38"
                        y2="17.5"
                        {stroke}
                        stroke-width="3"
                    />
                </svg>
            </div>
        </div>
        <div
            class="menu-back-style"
            bind:this={sideMenu}
            on:click={() => {
                sideMenu.style.left = '100vw';
                sideMenu.style.transitionDuration = '1s';
                sideMenu.style.top = '0vw';
                sideMenuInner.style.left = '100vw';
                sideMenuInner.style.transitionDuration = '1s';
                sideMenuInner.style.top = '0vw';
            }}
        />
        <div class="menu-section" bind:this={sideMenuInner}>
            <div class="logo-sidebar" on:click={() =>
             (location.href = '/')}>
                <img
                    src="/images/header/draper_logo.svg"
                    alt=" "
                    width="100%"
                />
            </div>
            <div class="hr-css">
                <hr class="hr" />
            </div>
            <div class="list">
                <ul
                    style="padding-left:5vw;height: 70vh;overflow-y: scroll;padding-bottom: 10vh;"
                >
                    <li>
                        <div
                            class="head-mbl "
                            on:click={() => {
                                if (
                                    menu === '' ||
                                    menu === 'government' ||
                                    menu === 'executives' ||
                                    (menu === 'investors' &&
                                        arrowdown.style.transform ===
                                            'rotate(0deg)') ||
                                    arrowdown2.style.transform ===
                                        'rotate(180deg)' ||
                                    arrowdown3.style.transform ===
                                        'rotate(180deg)' ||
                                    arrowdown4.style.transform ===
                                        'rotate(180deg)'
                                ) {
                                    menu = 'founder';
                                    arrowdown.style.transform =
                                        'rotate(180deg)';
                                    arrowdown2.style.transform = 'rotate(0deg)';
                                    arrowdown3.style.transform = 'rotate(0deg)';
                                    arrowdown4.style.transform = 'rotate(0deg)';
                                } else {
                                    menu = '';
                                    arrowdown.style.transform = 'rotate(0deg)';
                                }
                            }}
                        >
                            <div class="arrowdown" bind:this={arrowdown}>
                                <img
                                    src="/images/arrowDown.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div class="head-logo">
                                <img
                                    src="images/navbar/founder.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div>
                                <h5 class="h-clr">Founders</h5>
                            </div>
                        </div>
                        {#if menu === 'founder'}
                            <div class="menuHolder">
                                <div
                                    style="display: flex;
                            padding-left: 4vw;
                            justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/program_fundamental';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            1-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            Fundamental of Entrepreneurship
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                        >
                                            <div
                                                style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                            />
                                            virtual -2 weeks
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            Learning and networking with over 50
                                            Silicon Valley experts, mentors and
                                            global entrepreneurs.
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                                <div
                                    style="display: flex;
                            padding-left: 4vw;
                            justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/program_hero';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            2-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            Hero Training
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                        >
                                            <div
                                                style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                            />
                                            5 Weeks - Silicon Valley
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            An intensive, immersive five-week
                                            pre-accelerator program in Silicon
                                            Valley, CA.
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                                <div
                                    style="display: flex;
                                            padding-left: 4vw;
                                            justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/houseCeek';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            3-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            House of Ceek
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                        >
                                            <div
                                                style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                            />
                                            virtual -2 weeks
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            A fully sponsored program for VR
                                            Builders & Game Developers to create
                                            groundbreaking assets for the CEEK
                                            metaverse.
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                                <div
                                    style="display: flex;
                                            padding-left: 4vw;
                                            justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/kanoopage';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            4-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            Kanoo Innovation Hub
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                        >
                                            <div
                                                style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                            />
                                            virtual -2 weeks
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            We are developing and investing in
                                            the most powerful startups in the
                                            Caribbean along with Kanoo
                                            Innovation Hub. Join today!
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                            </div>
                        {/if}
                    </li>

                    <li>
                        <div
                            class="head-mbl"
                            on:click={() => {
                                if (
                                    menu === 'founder' ||
                                    menu === 'government' ||
                                    menu === '' ||
                                    (menu === 'investors' &&
                                        arrowdown2.style.transform ===
                                            'rotate(0deg)') ||
                                    arrowdown.style.transform ===
                                        'rotate(180deg)' ||
                                    arrowdown3.style.transform ===
                                        'rotate(180deg)' ||
                                    arrowdown4.style.transform ===
                                        'rotate(180deg)'
                                ) {
                                    menu = 'executives';
                                    arrowdown2.style.transform =
                                        'rotate(180deg)';
                                    arrowdown3.style.transform = 'rotate(0deg)';
                                    arrowdown4.style.transform = 'rotate(0deg)';
                                    arrowdown.style.transform = 'rotate(0deg)';
                                } else {
                                    menu = '';
                                    arrowdown2.style.transform = 'rotate(0deg)';
                                }
                            }}
                        >
                            <div class="arrowdown" bind:this={arrowdown2}>
                                <img
                                    src="/images/arrowDown.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div class="head-logo">
                                <img
                                    src="images/navbar/excute.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div>
                                <h5 class="h-clr">Executives</h5>
                            </div>
                        </div>
                        {#if menu === 'executives'}
                            <div class="menuHolder">
                                <div
                                    style="display: flex;
                            padding-left: 4vw;
                            justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/program_coporative';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            1-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            Corporate Innovation Program
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                        >
                                            <div
                                                style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                            />
                                            5 Week - Hybrid
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            Gain necessary knowledge,
                                            experience, and leadership skills to
                                            bringinnovation back to your company
                                            and team.
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                                <div
                                    style="display: flex;
                            padding-left: 4vw;
                            justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href =
                                            '/program_coporative_accelerator';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            2-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            Corporate Accelerators
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                        >
                                            <div
                                                style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                            />
                                            10 Weeks - Hybrid
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            Future-proof your business by
                                            investing and building with the most
                                            exciting startups in your industry.
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                                <div
                                    style="display: flex;
                        padding-left: 4vw;
                        justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/program_blockchain';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            3-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            Blockchain Accelerators
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                        >
                                            <div
                                                style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                            />
                                            10 Weeks - Hybrid
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            Partner with us to accelerate your
                                            blockchain ecosystem with superhero
                                            founders.
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                            </div>
                        {/if}
                    </li>

                    <li>
                        <div
                            class="head-mbl"
                            on:click={() => {
                                if (
                                    menu === 'founder' ||
                                    menu === 'government' ||
                                    menu === 'executives' ||
                                    (menu === '' &&
                                        arrowdown3.style.transform ===
                                            'rotate(0deg)') ||
                                    arrowdown2.style.transform ===
                                        'rotate(180deg)' ||
                                    arrowdown.style.transform ===
                                        'rotate(180deg)' ||
                                    arrowdown4.style.transform ===
                                        'rotate(180deg)'
                                ) {
                                    menu = 'investors';
                                    arrowdown3.style.transform =
                                        'rotate(180deg)';
                                    arrowdown4.style.transform = 'rotate(0deg)';
                                    arrowdown2.style.transform = 'rotate(0deg)';
                                    arrowdown.style.transform = 'rotate(0deg)';
                                } else {
                                    menu = '';
                                    arrowdown3.style.transform = 'rotate(0deg)';
                                }
                            }}
                        >
                            <div class="arrowdown" bind:this={arrowdown3}>
                                <img
                                    src="/images/arrowDown.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div class="head-logo">
                                <img
                                    src="images/navbar/invest.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div>
                                <h5 class="h-clr">Investors</h5>
                            </div>
                        </div>
                        {#if menu === 'investors'}
                            <div class="menuHolder">
                                <div
                                    style="display: flex;
                                    padding-left: 4vw;
                                    justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/program_vcx';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            1-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            VcX
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                        >
                                            <h6
                                                style="margin: 4vw 0;font-size: 2.6vw;"
                                            >
                                                Where new generations of
                                                entrepreneurial families around
                                                the world buildand network with
                                                top Silicon Valley VCs and
                                                founders leading the future.
                                            </h6>
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                                <div
                                    style="display: flex;
                                    padding-left: 4vw;
                                    justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/program_invest';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            2-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            Invest with us
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            We invest in founders building the
                                            future. If you want to get involved
                                            with pre-seed to pre-series A
                                            companies, join our investor
                                            network!
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                            </div>
                        {/if}
                    </li>
                    <li>
                        <div
                            class="head-mbl"
                            on:click={() => {
                                if (
                                    menu === 'founder' ||
                                    menu === '' ||
                                    menu === 'executives' ||
                                    (menu === 'investors' &&
                                        arrowdown4.style.transform ===
                                            'rotate(0deg)') ||
                                    arrowdown2.style.transform ===
                                        'rotate(180deg)' ||
                                    arrowdown.style.transform ===
                                        'rotate(180deg)' ||
                                    arrowdown3.style.transform ===
                                        'rotate(180deg)'
                                ) {
                                    menu = 'government';
                                    arrowdown4.style.transform =
                                        'rotate(180deg)';
                                    arrowdown3.style.transform = 'rotate(0deg)';
                                    arrowdown2.style.transform = 'rotate(0deg)';
                                    arrowdown.style.transform = 'rotate(0deg)';
                                } else {
                                    menu = '';
                                    arrowdown4.style.transform = 'rotate(0deg)';
                                }
                            }}
                        >
                            <div class="arrowdown" bind:this={arrowdown4}>
                                <img
                                    src="/images/arrowDown.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div class="head-logo">
                                <img
                                    src="images/navbar/govt.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div>
                                <h5 class="h-clr">Government</h5>
                            </div>
                        </div>
                        {#if menu === 'government'}
                            <div class="menuHolder">
                                <div
                                    style="display: flex;
                                            padding-left: 4vw;
                                            justify-content: space-evenly;"
                                    on:click={() => {
                                        location.href = '/program_global';
                                    }}
                                >
                                    <div>
                                        <h6
                                            style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                        >
                                            1-
                                        </h6>
                                    </div>
                                    <div style="width:70%;">
                                        <h6
                                            style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                        >
                                            Global Government Partnership
                                        </h6>
                                        <h6
                                            style="margin: 4vw 0;font-size: 2.6vw;"
                                        >
                                            Where new generations of
                                            entrepreneurial families around the
                                            world build and network with top
                                            Silicon Valley VCs and founders
                                            leading the future.
                                        </h6>
                                    </div>
                                </div>
                                <hr
                                    style="color: rgb(130, 172, 229);margin:0;"
                                />
                            </div>
                        {/if}
                    </li>
                </ul>
            </div>
            <div style="display: flex; justify-content: center;">
                <button class="btn-mbl-sidebar" on:click={() => (location.href = 'alumni')}>Alumni Success Stories</button>
                <div
                    style="font-size: 3.271vw;
                color: #3c74c0;
                position: absolute;
                bottom: 5.841vw;"
                    on:click={() => {
                        location.href = '/contact_us';
                    }}
                >
                    Contact Us
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .contactUs:hover {
        transform: scale(1.2);
        font-weight: 700;
        transition-duration: 0.2s;
        cursor: pointer;
    }
    .form-background {
        width: 100%;
        height: 100%;
        background-color: transparent;
        top: 0;
        left: 0;
        position: fixed;
        z-index: -3;
        display: none;
    }
    .navBackDiv {
        position: absolute;
        width: 7.57vw;
        height: 5.976vw;
        top: -1.5vw;
        background-color: #f7e05f;
        box-shadow: 0px 4px 4px 0px #00000040;
        z-index: -2;
        transition: height 0.2s;
        display: none;
    }
    .content-section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top-left-radius: 50vw;
        border-bottom-left-radius: 50vw;
    }
    .nav-list {
        /* width: 35vw; */
        width: 44.1vw;
        display: flex;
        justify-content: space-between;
        list-style-type: none;
        padding-left: 3.054vw;
        font-size: 1.058vw;
        font-weight: 400;
        margin-top: auto;
        margin-bottom: auto;
    }
    .content-section button {
        border: none;
        border-radius: 5vw;
        padding: 0.992vw 1.262vw 0.992vw 1.262vw;
        margin-right: 2.5vw;
        font-size: 1vw;
        font-weight: 400;
    }

    .select {
        transform: scale(1.2);
        font-weight: 700;
        transition-duration: 0.2s;
        cursor: pointer;
    }
    .menu ul li {
        cursor: pointer;
        padding: 0.5vw 0;
    }
    .arrowdown {
        width: 7vw;
        transform: rotate(0deg);
    }
    .menu ul li {
        margin: 0vw 1.5vw 0vw 1.5vw;
        cursor: pointer;
    }
    .btn-mbl-sidebar {
        border: 0;
        padding: 1vw 3vw 1vw 3vw;
        border-radius: 50vw;
        font-size: 3.271vw;
        background-color: #3c74c0;
        color: white;
        position: absolute;
        bottom: 12.57vw;
    }
    .menu-back-style {
        background-color: #eeeff196;
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 100vw;
        z-index: 3;
        top: 0vw;
    }
    .logo-img {
        width: 28vw;
    }
    .main-div {
        justify-content: space-between;
        display: flex;
        align-items: center;
        padding: 3vw;
        position: fixed;
        top: 0;
        width: 100vw;
        height: 18.692vw;
        z-index: 1;
        box-shadow: inset 0px 10px 8px -12px #ccc,
            inset 0px -10px 8px -12px #ccc;
    }
    .menu-section {
        position: fixed;
        height: 100vh;
        width: 67.056vw;
        background-color: #ffffff;
        z-index: 3;
        right: 0vw;
        cursor: pointer;
        left: 100vw;
        top: 0vw;
    }
    .head-mbl {
        display: flex;
        margin-top: 3vw;
        cursor: pointer;
        position: relative;
    }
    .h-clr {
        color: #3c74c0;
        margin-right: 6vw;
        font-size: 3.738vw;
        margin-top: 1.5vw;
    }
    .hr-css {
        width: 59.112vw;
        margin-top: 6.776vw;
        margin-left: 5.972vw;
    }
    .hr {
        color: #c4c4c4;
        opacity: 1;
        height: 2px;
        width: 90%;
    }
    .list {
        margin-top: 10vw;
    }
    .list ul {
        list-style-type: none;
        padding-left: 0;
    }
    .head-logo {
        margin-right: 5vw;
        width: 5.654vw;
    }
    .logo-sidebar {
        width: 40vw;
        margin-left: auto;
        margin-right: auto;
        margin-top: 6vw;
    }
    .mobile {
        padding: 0;
    }
    .mobi {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobi {
            display: block;
        }
    }
</style>
